import { type AxiosResponse } from "axios"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import { User } from "@/models/user.model"
import { type IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface"

export class AuthRepository {
  public async getDjangoUser(): Promise<User | null> {
    const response = await new HTTPRequestBuilder(HTTPMethods.GET, "auth/current-user/")
      .setExpectedStatusCode([200, 401])
      .build()
      .execute()
    if (response.status === 200) {
      return new User(response.data)
    }
    return null
  }

  public async acceptInvite(
    invitationCode: string,
    requestConfig?: IRepositoryRequestConfig
  ): Promise<AxiosResponse> {
    const request = new HTTPRequestBuilder(HTTPMethods.GET, `auth/accept-invite/${invitationCode}/`)
      .setExpectedStatusCode([200, 404, 409])
      .addStatusCodeHandlers(requestConfig?.statusCodeHandlers)
      .build()

    console.log("request headers", request.headers)
    return request.execute()
  }

  public async validateInviteCode(
    invitationCode: string,
    requestConfig?: IRepositoryRequestConfig
  ): Promise<AxiosResponse> {
    return new HTTPRequestBuilder(HTTPMethods.GET, `auth/validate-invite-code/${invitationCode}/`)
      .setExpectedStatusCode([200, 404])
      .addStatusCodeHandlers(requestConfig?.statusCodeHandlers)
      .build()
      .execute()
  }

  public async startImpersonation(userId: string): Promise<string> {
    const response = await new HTTPRequestBuilder(HTTPMethods.POST, "auth/impersonation/")
      .setData({ userId })
      .setExpectedStatusCode(200)
      .build()
      .execute()
    return response.data.token
  }
}
